<template>
  <v-dialog v-model="dialog" persistent width="500">
    <common-card>
      <v-card-text class="pa-4 black--text" style="text-align: center;">
        <div class="pt-5 pb-5 top-text text-data-details">
          Ingresar celular a recibir beneficio
        </div>
        <div class="pt-5 pb-5">
          <span class="confirmation-text text-data-details">
            Por favor, ingresa el número de celular.
          </span>
          <v-row class="pt-5">
            <v-col cols="12">
              <v-text-field
                v-model.trim="celularSaldo"
                label="Celular con saldo"
                outlined
                type="tel"
                maxlength="10"
                :rules="[$rules.required, telefonoRule]"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="6">
            <v-btn text color="#00a7e4" outlined dark style="border-radius: 15px;" @click="emitir(false)">
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn class="common-botton" dark @click="emitir(true)" :disabled="!celularValido">
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "../CommonCard.vue";

export default {
  components: { CommonCard },
  props: {
    dialog: Boolean
  },
  data() {
    return {
      celularSaldo: "",
      telefonoRule: (v) => /^\d{10}$/.test(v || "") || "Debe tener 10 dígitos",
    };
  },
  computed: {
    celularValido() {
      return /^\d{10}$/.test(this.celularSaldo || "");
    },
  },
  methods: {
    emitir(confirmado) {
      this.$emit("cerrar", confirmado, this.celularSaldo);
    }
  }
};
</script>
